import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { ApiVisa, BudgetFiscalYearService, Pagination } from 'blg-akaun-ts-lib';
import { AppConfig } from '../../visa';
import { SubSink } from 'subsink2';

@Component({
  selector: 'app-select-budget-fiscal-year-gen-doc',
  templateUrl: './select-budget-fiscal-year-gen-doc.component.html',
  styleUrls: ['./select-budget-fiscal-year-gen-doc.component.css']
})
export class SelectBudgetFiscalYearGenDocComponent  implements OnDestroy, OnChanges
{
  @Input() budgetFiscalYear = new FormControl();
  @Input() budgetVotebookGuid: string;
  @Output() selectionChange = new EventEmitter();

  private subs = new SubSink();
  separatorKeysCodes: number[] = [ENTER, COMMA];
  apiVisa: ApiVisa = AppConfig.apiVisa;

  allBudgetFiscalYears: any;
  searchBudgetFiscalYears: any = [];

  constructor(private budgetFiscalYearService: BudgetFiscalYearService) {}

  ngOnChanges(changes: SimpleChanges): void {
    if ("budgetVotebookGuid" in changes) {
      // React to changes in budgetVotebookGuid here
      const newGuid = this.budgetVotebookGuid;
      // Perform operations based on the new value
      if (newGuid !== null) {
        this.subs.sink = this.budgetFiscalYearService
          .getByCriteria(
            new Pagination(0, 10000, [
              {
                columnName: "votebook_guid",
                operator: "=",
                value: newGuid,
              },
            ]),
            this.apiVisa
          )
          .subscribe((compResponse) => {
            const budgetFiscalYearListing = compResponse.data.map(
              (data, index) => ({
                name: data.bl_fi_budget_fiscal_year.fiscal_year_name,
                code: data.bl_fi_budget_fiscal_year.fiscal_year_code,
                guid: data.bl_fi_budget_fiscal_year.guid,
              })
            );
            this.allBudgetFiscalYears = budgetFiscalYearListing;
            this.searchBudgetFiscalYears = budgetFiscalYearListing;
          });
      }
    }
  }

  applyBudgetFiscalYearFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
    this.searchBudgetFiscalYears = this.allBudgetFiscalYears.filter(
      (option) => option.name.toLowerCase().includes(filterValue)
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
